import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";
import { useCurrentTalentProfile } from "../../hooks";

const PremiumCardPurchased = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { darkMode } = useThemeStore();
  const navigate = useNavigate();

  const { currentProfile } = useCurrentTalentProfile();

  const handleClick = () => {
    navigate(`/talent/ace-lounge/${currentProfile?.id}?tab=premium`);
  };

  return (
    <Box onClick={handleClick} sx={wrapperStyles(darkMode)}>
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {notification?.title ?? "Premium Card Purchased"}
        </Typography>
        <Typography
          sx={{
            color: darkMode ? "#e5e7eb" : "#374151",
            font: "var(--body-xs)",
            fontWeight: 400,
          }}
        >
          {notification?.message ?? "Premium Card Purchased"}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#d1d5db" : "#4b5563",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PremiumCardPurchased;
